import { defineComponent as _defineComponent } from 'vue'
import { Editor } from '@toast-ui/vue-editor';
import {
  computed, onMounted, ref, toRefs, watch
} from 'vue';
import useToastUiEditorTools from '@/mixins/useToastUiEditorTools';
import { useVModel } from '@vueuse/core';
import useI18n from '@/mixins/useI18n';
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import ToastEditor from '@toast-ui/editor';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileRichTextEditor',
  props: {
  text: {
    type: String,
    default: ''
  },
  maxChars: {
    type: Number,
    default: 1000
  },
  maxCharsSource: {
    type: Number,
    default: 10000
  },
  charsLeftWarningThreshold: {
    type: Number,
    default: 50
  }
},
  emits: ['update:can-send'],
  setup(__props, { emit }) {

const props = __props;





const { t } = useI18n();
const { maxChars, maxCharsSource, charsLeftWarningThreshold } = toRefs(props);
const text = useVModel(props, 'text');
const editor = ref<ToastEditor>();
const isEnlarged = ref(false);
const tmpDiv = document.createElement('div');

const { createButton } = useToastUiEditorTools(editor);

const addImageBlobHook = (blob: any, callback: any) => {
  callback('', '');
};

const extendAutoLinks = () => null;

watch(
  isEnlarged,
  (is) => {
    if (editor.value) {
      editor.value.setHeight(is ? '600px' : '300px');
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (editor.value) {
    editor.value.on('change', () => {
      if (editor.value) {
        text.value = editor.value.getHTML();
      }
    });
  }
});

const getPlainTextLength = (str: string) => {
  tmpDiv.innerHTML = str;
  return tmpDiv.innerText.length;
};

const charactersLeft = computed(() => maxChars.value - getPlainTextLength(text.value));

const isPlaintextLengthOk = computed(() => charactersLeft.value >= 0);
const isHTMLLengthOk = computed(() => text.value.length < maxCharsSource.value);
const isPlaintextLengthCritical = computed(() => charactersLeft.value < charsLeftWarningThreshold.value);
const canSend = computed(() => isHTMLLengthOk.value && isPlaintextLengthOk.value);

const textLengthInfo = computed(() => {
  if (!isHTMLLengthOk.value) return t('common.tooMuchFormatting');
  const x = Math.abs(charactersLeft.value);
  if (charactersLeft.value < 0) return t('common.textTooLong', { x });
  return t('common.charactersLeft', { x });
});

const isTextLengthCritical = computed(() => isPlaintextLengthCritical.value || !isHTMLLengthOk.value);

watch(canSend, (canSend) => {
  emit('update:can-send', canSend);
}, { immediate: true });

const editorOptions = {
  usageStatistics: false,
  hideModeSwitch: true,
  autofocus: false,
  extendAutoLinks,
  hooks: {
    addImageBlobHook
  },
  toolbarItems: [
    [
      'bold',
      'italic',
      'hr',
      'quote',
      'ul',
      'ol',
      'indent',
      'outdent',
      'link',
      {
        el: createButton('undo'),
        command: 'undo',
        tooltip: 'Undo'
      },
      {
        el: createButton('redo'),
        command: 'redo',
        tooltip: 'Redo'
      }
    ]
  ]
};

return { __sfc: true,props, emit, t, maxChars, maxCharsSource, charsLeftWarningThreshold, text, editor, isEnlarged, tmpDiv, createButton, addImageBlobHook, extendAutoLinks, getPlainTextLength, charactersLeft, isPlaintextLengthOk, isHTMLLengthOk, isPlaintextLengthCritical, canSend, textLengthInfo, isTextLengthCritical, editorOptions, Editor, BCXIcon }
}

})